
<template>
  <div id="produpneu-app">

    <!-- Display current layout -->
    <component :is="currentLayout" :key="currentLayoutName">
      <router-view />
    </component>

    <!-- GLOBAL NOTIFICATIONS -->
    <GlobalToast />
  </div>
</template>

<script>
import PublicLayout from "./layouts/PublicLayout.vue";
import ClientLayout from "./layouts/ClientLayout.vue";
import AdminLayout from "./layouts/AdminLayout.vue";
import GlobalToast from "./components/common/GlobalToast.vue";

export default {
  name: "App",

  components: {
    PublicLayout,
    ClientLayout,
    AdminLayout,
    GlobalToast
  },

  computed: {
    currentLayoutName() {
      return this.$route.meta.layout || "public";
    },

    currentLayout() {
      const layouts = {
        public: "PublicLayout",
        client: "ClientLayout",
        admin: "AdminLayout",
      };

      return layouts[this.currentLayoutName] || "PublicLayout";
    },
  },
};
</script>

<style>
#produpneu-app {
  min-height: 100vh;
}
</style>
